import Link from 'next/link';

import { ProductDetail } from '@api/catalog/types';

import Tags from '@components/ProductCard/Tags';
import Picture from '@components/controls/future/Picture';

import { scale } from '@scripts/gds';
import { metricsSelectItem, transformImageUrl } from '@scripts/helpers';

const ProductCardTableCell = ({ productItem, image }: { productItem: ProductDetail; image: string }) => {
    const { name, code, id, nameplates } = productItem;

    return (
        <Link legacyBehavior href={`/product/${code}-${id}`} passHref prefetch={false}>
            <a
                aria-label={name}
                onClick={() => metricsSelectItem(productItem)}
                data-id={id}
                css={{
                    position: 'relative',
                    display: 'flex',
                    gap: scale(2),
                    alignItems: 'center',
                    ':hover': {
                        cursor: 'pointer',
                    },
                }}
            >
                <div
                    css={{
                        position: 'relative',
                        width: scale(8),
                        height: scale(8),
                    }}
                >
                    {image && (
                        <Picture
                            sources={[
                                {
                                    media: '',
                                    image: transformImageUrl(image, scale(8), scale(8)),
                                },
                            ]}
                            loading="lazy"
                            placeholder="blur"
                            alt={name || ''}
                            width="auto"
                            height="auto"
                            style={{
                                objectFit: 'contain',
                                objectPosition: 'center center',
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    )}
                </div>

                <div
                    css={{
                        overflow: 'hidden',
                        width: '100%',
                        WebkitBoxOrient: 'vertical',
                        display: '-webkit-box',
                        textOverflow: 'ellipsis',
                        WebkitLineClamp: 3,
                        maxWidth: scale(50),
                    }}
                >
                    {name}
                </div>

                <Tags tags={nameplates} />
            </a>
        </Link>
    );
};

export default ProductCardTableCell;
